<template>
  <div class="page page-conclusion">
    <div class="page-title">
      Диагнозы и Заключения
    </div>

    <div class="flash flash_error"
         v-if="error">
      {{error}}
    </div>

    <div v-if="!loaded" class="loader"></div>

    <div class="conclusion-title">Диагнозы</div>

    <ConclusionList
      :items="currentDiagnoses"
      type="diagnosis" />

    <div
      @click="showPastDiagnoses = !showPastDiagnoses"
      class="conclusion-history">
      <i class="fas fa-caret-down"></i>
      История диагнозов
    </div>

    <ConclusionList
      v-if="showPastDiagnoses"
      :items="pastDiagnoses"
      type="diagnosis" />

    <div class="conclusion-title">Функциональные состояния</div>

    <ConclusionList
      :items="currentFunctionals"
      type="functional" />

    <div
      @click="showPastFunctionals = !showPastFunctionals"
      class="conclusion-history">
      <i class="fas fa-caret-down"></i>
      История функциональных состояний
    </div>

    <ConclusionList
      v-if="showPastFunctionals"
      :items="pastFunctionals"
      type="functional" />

    <div class="conclusion-title">Заключения</div>

    <ConclusionList
      :items="conclusions"
      type="conclusion" />
  </div>
</template>

<script>
import ConclusionList from './conclusion/List';

export default {
  name: 'Conclusion',

  components: {ConclusionList},

  data() {
    return {
      loaded: false,
      error: '',
      showPastDiagnoses: false,
      showPastFunctionals: false,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    diagnoses() {
      const data = this.$store.state.diagnoses.map(item => {
        return {
          id: item.id,
          title: typeof item.diagnosis !== 'undefined' ? item.diagnosis.title : '',
          dateFrom: typeof item.dateFrom === 'string' ? new Date(item.dateFrom) : null,
          dateTo: typeof item.dateTo === 'string' ? new Date(item.dateTo) : null,
          type: item.type,
        };
      });

      data.sort((a, b) => a.dateFrom.getTime() - b.dateFrom.getTime());

      return data;
    },

    functionals() {
      const data = this.$store.state.functionals.map(item => {
        return {
          id: item.id,
          title: typeof item.functional !== 'undefined' ? item.functional.title : '',
          dateFrom: typeof item.dateFrom === 'string' ? new Date(item.dateFrom) : null,
          dateTo: typeof item.dateTo === 'string' ? new Date(item.dateTo) : null,
          type: item.type,
        };
      });

      data.sort((a, b) => a.dateFrom.getTime() - b.dateFrom.getTime());

      return data;
    },

    conclusions() {
      const data = this.$store.state.conclusions.map(item => {
        return {
          id: item.id,
          title: item.text,
          dateFrom: new Date(item.dateFrom),
          type: item.type,
        };
      });

      data.sort((a, b) => a.dateFrom.getTime() - b.dateFrom.getTime());

      return data;
    },

    currentDiagnoses() {
      return this.diagnoses.filter(i => i.dateTo === null);
    },

    pastDiagnoses() {
      return this.diagnoses.filter(i => i.dateTo !== null);
    },

    currentFunctionals() {
      return this.functionals.filter(i => i.dateTo === null);
    },

    pastFunctionals() {
      return this.functionals.filter(i => i.dateTo !== null);
    },
  },

  methods: {
    async loadData() {
      this.loaded = false;
      this.error = '';

      try {
        await Promise.all([
          this.$store.dispatch('LOAD_DIAGNOSES'),
          this.$store.dispatch('LOAD_CONCLUSIONS'),
          this.$store.dispatch('LOAD_FUNCTIONALS'),
        ]);
      } catch(e) {
        this.error = 'Произошла ошибка. Повторите попытку позже.';
      }

      this.loaded = true;
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.page-conclusion {
  .conclusion-title {
    position: relative;
    margin: 10px 0 0;
    padding: 10px 0 10px 20px;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    color: $primary;
    background-color: $light-gray-bg;
    border-top: 2px solid $primary;
  }

  .conclusion-history {
    padding: 10px 20px;
    font-size: 14px;
    color: $primary;
  }
}
</style>
